var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLockKeyhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3334V15.0001M6.25 18.3334H13.7504C15.1311 18.3334 16.2504 17.2141 16.2504 15.8334V9.72233C16.2504 8.34162 15.1311 7.22233 13.7504 7.22233H6.25C4.86929 7.22233 3.75 8.34161 3.75 9.72233V15.8334C3.75 17.2141 4.86929 18.3334 6.25 18.3334ZM13.1253 7.22229V4.79185C13.1253 3.0659 11.7262 1.66675 10.0002 1.66675C8.27426 1.66675 6.87511 3.0659 6.87511 4.79185V7.22229H13.1253ZM11.25 11.6667C11.25 12.3571 10.6904 12.9167 10 12.9167C9.30964 12.9167 8.75 12.3571 8.75 11.6667C8.75 10.9764 9.30964 10.4167 10 10.4167C10.6904 10.4167 11.25 10.9764 11.25 11.6667Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKeyhole);
export default __webpack_public_path__ + "static/media/lock-keyhole.3451f44493b4c46811eb9c5f8e5a482c.svg";
export { ForwardRef as ReactComponent };